import { useState, useRef, useCallback } from 'react';

export const useSpeakerTest = (audioOutputDeviceId?: string | null) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const playTestSound = useCallback(async () => {
    if (isPlaying) {
      // Останавливаем воспроизведение
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      setIsPlaying(false);
      return;
    }

    try {
      // Создаем новый audio элемент если его нет
      if (!audioRef.current) {
        audioRef.current = new Audio('/oboe.mp3');
      }

      const audio = audioRef.current;

      // Устанавливаем выбранное устройство вывода, если поддерживается
      if (audioOutputDeviceId && 'setSinkId' in audio) {
        await (audio as any).setSinkId(audioOutputDeviceId);
      }

      // Воспроизводим
      audio.currentTime = 0;
      await audio.play();
      setIsPlaying(true);

      // Обработчик завершения
      audio.onended = () => {
        setIsPlaying(false);
      };
    } catch (error) {
      console.error('Failed to play test sound:', error);
      setIsPlaying(false);
    }
  }, [isPlaying, audioOutputDeviceId]);

  const stopTestSound = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setIsPlaying(false);
  }, []);

  return { isPlaying, playTestSound, stopTestSound };
};
